import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import Button from '../../../../../../form/buttons/Button/Button';
import {defaultValues} from '../../../../forms/EmmaiPractitionerForm/helpers/defaultValues';
import usePractitionerNavigation from '../../../usePractitionerNavigation/usePractitionerNavigation';

const BackToPractitionerActivityButton = () => {
  const {setCurrentForm, setIsPractitionerUpdating, practitionerFormMethods} = useEmmai();
  const {goToPractitionerActivity} = usePractitionerNavigation({
    setCurrentForm,
    setIsPractitionerUpdating
  });

  const toolbarStyles = {
    backgroundColor: 'white !important',
    color: 'primary.main',
    fontWeight: 600,
    fontSize: 11,
    maxHeight: 20,
    mr: {xs: 0.5, sm: 1},
    '&:hover': {
      backgroundColor: '#dedede'
    }
  };

  return (
    <Button
      onClick={() => {
        practitionerFormMethods.reset(defaultValues);
        goToPractitionerActivity();
      }}
      size="small"
      color="white"
      sx={toolbarStyles}
    >
      Retour
    </Button>
  );
};

export default BackToPractitionerActivityButton;
